import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon, SunIcon, MoonIcon, GlobeIcon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
export function Navigation() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    theme,
    toggleTheme
  } = useTheme();
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const navLinks = [{
    label: t('nav.about'),
    href: '#about'
  }, {
    label: t('nav.members'),
    href: '#members'
  }, {
    label: t('nav.projects'),
    href: '#projects'
  }, {
    label: t('nav.events'),
    href: '#events'
  }, {
    label: t('nav.news'),
    href: '#news'
  }, {
    label: t('nav.contacts'),
    href: '#contacts'
  }];
  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'ua' : 'en');
  };
  return <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl nav-blur transition-colors duration-300" style={{
    borderBottom: '1px solid var(--border)'
  }} data-id="element-278">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-5 flex items-center justify-between" data-id="element-279">
        {/* Logo */}
        <a href="#" className="flex items-center gap-1" data-id="element-280">
          <span className="text-xl sm:text-2xl font-bold tracking-tight" style={{
          color: 'var(--text-primary)'
        }} data-id="element-281">
            IT Cluster
          </span>
          <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full" style={{
          backgroundColor: 'var(--accent)'
        }} data-id="element-282" />
        </a>

        {/* Desktop nav links */}
        <div className="hidden lg:flex items-center gap-8" data-id="element-283">
          {navLinks.map(link => <a key={link.href} href={link.href} className="text-sm font-medium transition-colors hover:opacity-80" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-284">
              {link.label}
            </a>)}
        </div>

        {/* Actions */}
        <div className="flex items-center gap-3 sm:gap-4" data-id="element-285">
          <button onClick={toggleLanguage} className="flex items-center gap-1.5 p-2 rounded-lg transition-colors hover:bg-[var(--bg-tertiary)]" style={{
          color: 'var(--text-primary)'
        }} aria-label="Toggle language" data-id="element-286">
            <GlobeIcon className="w-4 h-4" data-id="element-287" />
            <span className="text-sm font-medium uppercase" data-id="element-288">{language}</span>
          </button>

          <button onClick={toggleTheme} className="p-2 rounded-lg transition-colors hover:bg-[var(--bg-tertiary)]" style={{
          color: 'var(--text-primary)'
        }} aria-label="Toggle theme" data-id="element-289">
            {theme === 'light' ? <MoonIcon className="w-5 h-5" data-id="element-290" /> : <SunIcon className="w-5 h-5" data-id="element-291" />}
          </button>

          <a href="#join" className="hidden sm:inline-flex px-6 py-2.5 rounded-lg text-sm font-medium transition-all hover:scale-105 whitespace-nowrap" style={{
          backgroundColor: 'var(--accent)',
          color: '#FFFFFF'
        }} data-id="element-292">
            {t('nav.join')}
          </a>

          <button className="lg:hidden p-2 rounded-lg" style={{
          color: 'var(--text-primary)'
        }} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-293">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-294" /> : <MenuIcon className="w-6 h-6" data-id="element-295" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-296">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden border-t overflow-hidden" style={{
        backgroundColor: 'var(--bg-secondary)',
        borderColor: 'var(--border)'
      }} data-id="element-297">
            <div className="px-4 py-6 flex flex-col gap-4" data-id="element-298">
              {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-base font-medium py-2" style={{
            color: 'var(--text-primary)'
          }} data-id="element-299">
                  {link.label}
                </a>)}
              <a href="#join" onClick={() => setIsMobileMenuOpen(false)} className="mt-4 text-center px-6 py-3 rounded-lg text-sm font-medium transition-all" style={{
            backgroundColor: 'var(--accent)',
            color: '#FFFFFF'
          }} data-id="element-300">
                {t('nav.join')}
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}